import React from "react";

import { Avatar, AvatarGroup, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { FileSharedWith } from "store/types";

interface Props {
  users: FileSharedWith[];
}
export const SharedCell: React.FC<Props> = ({ users }) => {
  if (!users?.length) {
    return <Typography sx={{ fontSize: 14, color: "#92a7bc", lineHeight: "16px" }}>-</Typography>;
  }
  const names = users.map((u) => u.full_name).join(", ");
  return (
    <MaterialTooltip title={names}>
      <AvatarGroup
        max={3}
        sx={{
          justifyContent: "flex-start",
          "& .MuiAvatar-root": { width: 24, height: 24, fontSize: 10, border: "none" }
        }}
      >
        {users.map((user) => (
          <Avatar key={user.id} src={user.profile_photo_url} alt={user.full_name} sx={{ width: 24, height: 24 }} />
        ))}
      </AvatarGroup>
    </MaterialTooltip>
  );
};
